import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
// import { environment } from './environments/environment';

// if (!environment.production) {
//     // Startup diagnostics logs
//     console.info('[BOOT] Starting Angular app');
//     console.info('[BOOT] Environment.production =', environment.production);
//     console.info('[BOOT] Environment.useMocks =', environment.useMocks);
//     try {
//         console.info('[BOOT] Window host =', window.location.host);
//         console.info('[BOOT] Window origin =', window.location.origin);
//     } catch (e) {
//         console.info('[BOOT] window.location not available');
//         console.debug('[BOOT] Error accessing window.location:', e);
//     }
// }

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
